<div class="content-body user-list">
    <div class="content-header">
      <div class="content-header-input">
        <div class="d-flex">
          <button
            class="action-button primary-button"
            mat-button
            #button
            disableRipple
            (click)="openDialog()"
          >
            <mat-icon>add</mat-icon>
            <span>Submit Accounts</span>
          </button>
          <div class="d-flex align-items-center gap-10">
            <span class="fw-bold">Period: </span>
            <mat-form-field class="w-200">
              <mat-select
                panelClass="mat-select-position"
                [disableOptionCentering]="true"
                [(ngModel)]="accountingId"
                (selectionChange)="getSubmitMainGridDetail()"
              >
                <mat-option
                  *ngFor="let option of periodicDateList"
                  [value]="option.id"
                  title="{{ option.fromDate | date: 'dd-LLL-yyyy' }} - {{
                    option.toDate | date: 'dd-LLL-yyyy'
                  }}"
                >
                  {{ option.fromDate | date: "dd-LLL-yyyy" }} -
                  {{ option.toDate | date: "dd-LLL-yyyy" }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>          
        </div>
        
      </div>
    </div>
    <div class="top-list-wrapper mb-10">
            <div class="list-card mb-0">
              <div class="d-flex gap-20">
                <div class="list-card-cant">
                  <mat-icon fontSet="material-icons-outlined">info</mat-icon>
                  <span class="pl-5">
                    Please wait for 10 seconds and click on pending to check the submission status.
                  </span>
                </div>
              </div>
            </div>
          </div>
    <div class="mat-table-wrapper">
      <table
          mat-table
          [dataSource]="dataSubmitSource"
          aria-describedby="Submit Table"
        >
        
          <ng-container matColumnDef="from">
            <th mat-header-cell *matHeaderCellDef>From</th>
            <td mat-cell *matCellDef="let element">
                <div class="white-space-nowrap">{{ element.reportStartdate | date: 'dd-LLL-yyyy' }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="to">
            <th mat-header-cell *matHeaderCellDef>To</th>
            <td mat-cell *matCellDef="let element">
                <div class="white-space-nowrap">{{ element.reportEndDate | date: 'dd-LLL-yyyy' }}</div>
            </td>
          </ng-container>
          
          
          <ng-container matColumnDef="subdate">
            <th mat-header-cell *matHeaderCellDef>Submission Date</th>
            <td mat-cell *matCellDef="let element">
                <div class="white-space-nowrap">{{ element.submitDate | date: 'dd-LLL-yyyy' }}</div>
            </td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef class="w-170">Status</th>
            <td mat-cell *matCellDef="let element; let i = index">              
              <div class="d-flex align-items-center justify-space-between">
                <div class="white-space-nowrap">
                  <a href="javascript:void" (click)="(element?.submissionStatus !== 'Accepted')?showData(element?.submitId):''"><span [ngClass]="element?.submissionStatus === 'Error'|| element?.submissionStatus === 'Rejected' ? 'text-danger-100 link' : (element?.submissionStatus === 'Accepted' ? 'status-active' : 'text-primary link')">{{ element.submissionStatus }}</span></a>
                  <!-- <span [ngClass]="element?.submissionStatus === 'Pending' ? 'text-primary' : (element?.submissionStatus === 'Error'|| element?.submissionStatus === 'Rejected' ? 'text-danger-100' : (element?.submissionStatus === 'Accepted' ? 'status-active' : ''))">{{ element.submissionStatus }}</span> -->
                </div>

                <div
                  class="grid-actions"
                  [ngClass]="selectedRowIndex === i ? 'show-button' : ''"
                >
                  <div class="d-flex align-items-center">
                    <button
                      *ngIf="element?.submissionStatus === 'Error'"
                      mat-button
                      title="Submit To Companies House"
                      (click)="redirectToSubmit(element?.reportId, element?.submitId)"
                      >
                      <mat-icon fontSet="material-icons-outlined">content_paste_go</mat-icon>
                    </button>
                    <button
                      mat-button
                      disableRipple
                      title="Download report as iXBRL"
                      (click)="downloadReport(element?.reportId)"
                      >
                      <mat-icon fontSet="material-icons-outlined">download</mat-icon>
                    </button>
                    <button
                      *ngIf="element?.submissionStatus !== 'Error'"
                      mat-button
                      disableRipple
                      title="Download response as PDF"
                      (click)="downloadReportAsPDF(element?.submitId)"
                      >
                      <mat-icon fontSet="material-icons-outlined">picture_as_pdf</mat-icon>
                    </button>
                    <button
                    *ngIf="element?.submissionStatus === 'Error'"
                      mat-button
                      title="Delete"
                      disableRipple
                      (click)="onDeleteClick(element?.submitId)"
                    >
                      <mat-icon>delete_outline</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedSubmitColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedSubmitColumns"></tr>
      </table>
      <div *ngIf="!dataSubmitSource?.length" class="text-align-center mt-1">
        No records found
      </div>
    </div>
</div>